import { addNewRelicPageAction } from '@ddc/new-relic';
import { deprecatedFacets } from '../global-constants';

/**
 * Filters out deprecated facets from the facet array.
 * Includes New Relic tracking to monitor if deprecated facets are still being returned.
 *
 * Related to TA3628492: Add tracking and evaluate necessity of removeDeprecatedFacets utility
 *
 * @param {Array} facetArray - Array of facet objects with id property
 * @returns {Array} Filtered array with deprecated facets removed
 */
export const removeDeprecatedFacets = (facetArray = []) => {
	const originalCount = facetArray.length;
	const filteredArray = facetArray.filter(
		({ id }) => !deprecatedFacets.includes(id)
	);
	const removedCount = originalCount - filteredArray.length;

	// Track when deprecated facets are actually removed
	if (removedCount > 0) {
		const removedFacetIds = facetArray
			.filter(({ id }) => deprecatedFacets.includes(id))
			.map(({ id }) => id);

		addNewRelicPageAction('WS INV DATA DEPRECATED FACETS REMOVED', {
			removedCount,
			removedFacetIds: removedFacetIds.join(', '),
			originalCount,
			filteredCount: filteredArray.length
		});
	}

	return filteredArray;
};
